import { render, staticRenderFns } from "./FormattedTextLight.vue?vue&type=template&id=4fd0b265&scoped=true"
import script from "./FormattedTextLight.vue?vue&type=script&lang=ts"
export * from "./FormattedTextLight.vue?vue&type=script&lang=ts"
import style0 from "./FormattedTextLight.vue?vue&type=style&index=0&id=4fd0b265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd0b265",
  null
  
)

export default component.exports